import { useEffect, useState } from 'react';
import moment from 'moment';
import { BackendDateFormat } from 'utils/constants';


const useWeekSchedules = (
  schedules: any[],
  startDate: string | null | any
) => {
  const [filteredSchedules, setFilteredSchedules] = useState<any[]>([]);

  useEffect(() => {
    if (!schedules || schedules.length === 0 || startDate === null) {
      setFilteredSchedules([]);
      return;
    }

    const start = moment.parseZone(startDate);
    const end = moment.parseZone(startDate).add(7, 'days');

    const filtered = schedules.filter(schedule => {
      const scheduleDate = moment.parseZone(schedule.checkin_time,BackendDateFormat);
      return (
        (scheduleDate.isSame(start, 'day') || scheduleDate.isBetween(start, end, undefined, '[]'))
      );
    });

    setFilteredSchedules(filtered);
  }, [schedules,startDate]);

  return filteredSchedules;
};

export default useWeekSchedules;
